// extracted by mini-css-extract-plugin
export default {"text":"CodeInput_text__C3hNr"};